export const ROUTE_AUTH_LOGIN = '/login'
export const ROUTE_AUTH_LOGOUT = '/logout'
export const ROUTE_AUTH_RESET_PASSWORD = '/reset'
export const ROUTE_AUTH_RECOVERY = '/recovery'
export const ROUTE_AUTH_REGISTER = '/register'
